import {
  fileFormatter,
  userTag,
  userTagGroup,
  formatSeverity,
  IDcounter,
  imageFormatter,
  statusFormatter,
  descriptionTemplate,
  formatDateField,
  type FormatterColDef,
  type DataContext,
  type GridLike,
  type FormatterDateColDef,
} from "./Formatters";

/** Matches the SlickGrid formatter callback signature */
type GridCellFormatter = (
  row: number,
  cell: number,
  value: unknown,
  columnDef: FormatterColDef & FormatterDateColDef,
  dataContext: DataContext,
  grid?: GridLike,
) => HTMLElement | string;

export const FORMATTER_REGISTRY: Record<string, GridCellFormatter> = {
  file: fileFormatter,
  image: imageFormatter,
  ID: IDcounter,
  userTag: userTag,
  userTagGroup: userTagGroup,
  severity: formatSeverity,
  Date: formatDateField,
  status: statusFormatter,
  description: descriptionTemplate,
};

export const getFormatterByType = (formatterType?: string) => {
  if (!formatterType) return undefined;
  return FORMATTER_REGISTRY[formatterType];
};
